import React, { useEffect, useState } from "react";
import { SuperAdminShell } from "../components/SuperAdminShell";
import saApi from "../lib/saApi";
import { Building2, Users, LayoutDashboard, Database, Zap, ShieldAlert, Loader2 } from "lucide-react";

function Kpi({ label, value, icon: Icon, accent = "#22D3EE", hint, testid }) {
  return (
    <div data-testid={testid} className="rounded-2xl p-5 border border-white/10 backdrop-blur-md"
         style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))" }}>
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-widest text-white/50">{label}</div>
        <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${accent}22` }}>
          <Icon className="w-4 h-4" style={{ color: accent }} />
        </div>
      </div>
      <div className="mt-3 text-3xl font-display text-white">{value}</div>
      {hint && <div className="mt-1 text-[11px] text-white/40">{hint}</div>}
    </div>
  );
}

export default function SAHome() {
  const [d, setD] = useState(null);
  useEffect(() => { saApi.get("/overview").then(({ data }) => setD(data)).catch(() => setD({})); }, []);
  return (
    <SuperAdminShell title="Overview">
      <div className="px-5 md:px-8 py-6 space-y-6">
        {d === null ? (
          <div className="flex items-center gap-2 text-white/60"><Loader2 className="w-4 h-4 animate-spin" />Loading…</div>
        ) : (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              <Kpi testid="sa-kpi-tenants" label="Tenants" value={d.tenants ?? "—"} icon={Building2} accent="#22D3EE" />
              <Kpi testid="sa-kpi-users" label="Users" value={d.users ?? "—"} icon={Users} accent="#A78BFA" />
              <Kpi testid="sa-kpi-dashboards" label="Dashboards" value={d.dashboards ?? "—"} icon={LayoutDashboard} accent="#F472B6" />
              <Kpi testid="sa-kpi-datasets" label="Datasets" value={d.datasets ?? "—"} icon={Database} accent="#34D399" />
              <Kpi testid="sa-kpi-ai-calls" label="AI Calls (7d)" value={d.ai_calls_7d ?? "—"} icon={Zap} accent="#FBBF24" />
              <Kpi testid="sa-kpi-failed-logins" label="Failed Logins (24h)" value={d.failed_logins_24h ?? "—"} icon={ShieldAlert} accent="#F87171"
                   hint="Includes lockouts" />
            </div>
            <div className="rounded-2xl p-6 border border-white/10 backdrop-blur-md"
                 style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))" }}>
              <h2 className="font-display text-lg text-white">Welcome to the Cockpit</h2>
              <p className="text-sm text-white/60 mt-2 max-w-2xl leading-relaxed">
                From here you can operate the platform across all tenants — audit any activity, right-size storage & AI budgets,
                mint new super admin identities with fine-grained scopes, and dictate the global settings that ship to every client workspace.
                Use the tenant filter in the top-right to focus any mirrored view on a single customer.
              </p>
            </div>
          </>
        )}
      </div>
    </SuperAdminShell>
  );
}
